<!-- src/components/Home.vue -->

<template>
  <div>
    <header-component />
    <termsConditionBanner-component />
    <footer-component />
  </div>
</template>

<script>
import headerComponent from '../header/headerComponent.vue';
import termsConditionBannerComponent from '../termsCondition/termsConditionBannerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'homeComponent',
  components: {
    headerComponent,
    termsConditionBannerComponent,
    footerComponent,
  },
};
</script>
